import type { ButtonHTMLAttributes, ReactNode } from 'react';

export type ButtonTone = 'brand' | 'primary' | 'positive' | 'secondary' | 'quiet' | 'destructive' | 'ai';
export type ButtonSize = 'sm' | 'md' | 'lg';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  tone?: ButtonTone;
  size?: ButtonSize;
  icon?: ReactNode;
  trailingIcon?: ReactNode;
}

export function Button({
  tone = 'primary',
  size = 'md',
  icon,
  trailingIcon,
  className = '',
  children,
  type = 'button',
  ...props
}: ButtonProps) {
  return (
    <button
      type={type}
      className={`altios-button altios-button--${tone} altios-button--${size} ${className}`.trim()}
      {...props}
    >
      {icon ? <span className="altios-button__icon" aria-hidden="true">{icon}</span> : null}
      <span>{children}</span>
      {trailingIcon ? <span className="altios-button__icon" aria-hidden="true">{trailingIcon}</span> : null}
    </button>
  );
}
